import React from "react";
import HEADER from "../header/Header.component";
import FOOTER from "../footer/Footer.component";
import { IBaseLayoutProps } from "./Layout.types";
import { Col, Row } from "react-bootstrap";
import LayoutStyles from "./Layout.styles";
import PAGE_HEADING from "../page/page-heading/PageHeading.component";
import { useHistory } from "react-router-dom";
import BUTTON from "../button/Button.component";
import { ClickEvent } from "../../shared/types/event.types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { useAppDispatch } from "../../state-management/store";
import { clearSelectedPackage } from "../../state-management/slices/packageSelector/package-selector.slice";
import {
  setOffset,
  setCurrentPage,
} from "../../state-management/slices/pagination/pagination.slice";
import { clearSearchTerm } from "../../state-management/slices/search/search.slice";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { useSelector } from "react-redux";
import { RootState } from "../../state-management/root-reducer";

const DETAILS_LAYOUT: React.FC<IBaseLayoutProps> = (
  props: IBaseLayoutProps
) => {
  const { children, title } = props;

  const dispatch = useAppDispatch();
  const sendDataToGTM = useGTMDispatch();
  const history = useHistory();

  // App State
  const { searchTerm } = useSelector((state: RootState) => state.search);

  return (
    <>
      <HEADER />
      <LayoutStyles.GridContainer
        className="grid-container details-view"
        fluid="xl"
        data-testid="details-grid-container"
      >
        <Row>
          <Col xs={12}>
            <BUTTON
              variant="secondary"
              className="back-button blue-theme no-scale"
              onClick={(event: ClickEvent) => {
                event.preventDefault();
                sendDataToGTM({
                  event: "eventTracking",
                  category: "Construction",
                  action: "Click - Project Details",
                  label: "Back button",
                });

                /* istanbul ignore next */
                if (searchTerm && searchTerm.length > 0) {
                  dispatch(clearSearchTerm());
                  dispatch(setOffset(0));
                  dispatch(setCurrentPage(1));
                }

                dispatch(clearSelectedPackage());
                history.push("/");
              }}
            >
              <div>
                <FontAwesomeIcon
                  className="back-arrow blue-theme"
                  icon={faAngleLeft}
                />
                Back
              </div>
            </BUTTON>
            <PAGE_HEADING title={title} />
          </Col>
        </Row>
        <Row>{children}</Row>
      </LayoutStyles.GridContainer>
      <FOOTER />
    </>
  );
};
export default DETAILS_LAYOUT;
